// import { jwtDecode } from "jwt-decode";
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Navigate,
//   Route,
//   BrowserRouter as Router,
//   Routes,
//   useLocation,
// } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import CreateProject from "../src/NewCompoents/Client/Project/CreateProject";
// import "./App.css";
// import Approval from "./Components/Admin/Approval";
// import AudioPage from "./Components/AudioPage/AudioPage";
// import AuthComponent from "./Components/AuthComponent/AuthComponent";
// import Blog from "./Components/Blog/Blog";
// import CallTypeComponent from "./Components/CallTypeComponent/CallTypeComponent";
// import CreateInBoundAgentComponent from "./Components/CreateAgentComponent/CreateInBoundAgentComponent";
// import CreateOutBoundAgentComponent from "./Components/CreateAgentComponent/CreateOutBoundAgentComponent";
// import CustomerSupport from "./Components/CustomerSupport/CustomerSupport";
// import FaqComponent from "./Components/FaqComponent/FaqComponent";
// import HelpCenter from "./Components/HelpCenter/HelpCenter";
// import HomeComponent from "./Components/HomeComponent/HomeComponent";
// import InboundTemplate from "./Components/InboundTemplate/InboundTemplate";
// import KnowledgeBase from "./Components/KnowledgeBase/KnowledgeBase";
// import NumberManagement from "./Components/NumberManagement/NumberManagement";
// import OutboundCallDashboard from "./Components/OutboundCallDashboard/OutboundCallDashboard";
// import OutboundTemplate from "./Components/OutboundTemplate/OutboundTemplate";
// import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
// import Campaign from "./Components/RealStateVendor/Campaign";
// import Developer from "./Components/RealStateVendor/Developer";
// import ResultComponent from "./Components/ResultComponent/ResultComponent";
// import ScriptandApi from "./Components/Script&Api/ScriptandApi";
// import Setting from "./Components/Setting/Setting";
// import Sidebar from "./Components/Sidebar/Sidebar";
// import TemplateComponent from "./Components/TemplateComponent/TemplateComponent";
// import TermsOfService from "./Components/TermsOfService/TermsOfService";
// import ToxboxSection from "./Components/ToxboxSection/ToxboxSection";
// import VoiceComponent from "./Components/VoiceComponent/VoiceComponent";
// import AdminDashboard from "./NewCompoents/Admin/AdminDashboard/AdminDashboard";
// import AssignComponent from "./NewCompoents/AssignComponent/AssignComponent";
// import CallBook from "./NewCompoents/CallBook/CallBook";
// import CallDetails from "./NewCompoents/Client/CallHistory/CallDetails";
// import HeaderBar from "./NewCompoents/HeaderBar/HeaderBar";
// import SubAdminDashboard from "./NewCompoents/SubAdmin/SubAdminDashboard/SubAdminDashboard";
// import UserManagement from "./NewCompoents/UserManagement/UserManagement";
// import VendorBalancePage from "./NewCompoents/VendorBalancePage/VendorBalancePage";
// import AgentAssignComponent from "./Components/AgentAssignComponent/AgentAssignComponent";
// import EditAgentComponent from "./Components/EditAgentComponent/EditAgentComponent";
// import ShowTicket from "./Components/HelpCenter/ShowTicket";
// import NewChatBot from "./Components/NewChatbot/NewChatBot";
// import VendorDashboard from "./Components/VendorDashboard/VendorDashboard";
// import BalanceStatement from "./NewCompoents/BalanceStatement/BalanceStatement";
// import CallLogsCampaign from "./NewCompoents/CallLogsCampaign/CallLogsCampaign";
// import CallHistory from "./NewCompoents/Client/CallHistory/CallHistory";
// import Playground from "./NewCompoents/Playground/Playground";
// import CorpusSources from "./NewCompoents/Rag/CorpusSources";
// import VendorKnowledge from "./NewCompoents/Rag/VendorKnowledge";
// import AgentScriptFull from "./NewCompoents/SalesPerson/SalesPersonDashboard/AgentScriptFull";
// import SalesPersonDashboard from "./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonDashboard";
// import SalesPersonInfo from "./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonInfo";
// import { logout } from "./redux/authSlice";
// import ScrollToTop from "./ScrollToTop";
// import LeadQualification from "../src/NewCompoents/SalesAgent/LeadQualification";
// import NewandMedia from "./Components/AINews&Media/NewandMedia";
// import AIRecruiter from "./Components/AIRecruiter/AIRecruiter";
// import AITechSupport from "./Components/AITechSupport/AITechSupport";
// import HardwareSupport from "./Components/HardwareSupport/HardwareSupport";
// import DynamicPage from "./Components/HomeComponent/DynamicPage/DynamicPage";
// import Navbar from "./Components/HomeComponent/Navbar";
// import SoftwareAssistance from "./Components/SoftwareAssistance/SoftwareAssistance";
// import WhyToxbox from "./Components/WhyUs/WhyToxbox";
// import DemoForm from "./NewCompoents/Demoform/DemoForm";
// import DemoList from "./NewCompoents/Demoform/DemoList/DemoList";
// import LiveChatSupport from "./NewCompoents/LiveChatSupport/LiveChatSupport";
// import FollowUpManagement from "./NewCompoents/SalesAgent/FollowUpManagement";
// import SalesPitchAutomation from "./NewCompoents/SalesAgent/SalesPitchAutomation";
// import TicketResolution from "./NewCompoents/TicketResolution/TicketResolution";
// import Careers from "./Components/Career/Careers";
// import FooterComponent from "./Components/Footer/FooterComponent";
// import KeysComponent from "./Components/KeysComponent/KeysComponent";
// import ConnectMetaAds from "./Components/MetaIntegration/ConnectMetaAds";
// import CampaignsDashboard from "./Components/MetaIntegration/CampaignsDashboard";
// import LeadsDashboard from "./Components/MetaIntegration/LeadsDashboard";
// import MultiStepForm from "./Components/MultiStepForm/MultiStepForm";
// import RecruiterAgnetPage from "./Components/Recruiter/RecruiterAgent/MultiStepForm/RecruiterAgentPage";
// import ApiKeyGenerator from "./Components/Recruiter/RecruiterApiKey/ApiKeyGenerator";
// import AllRecuiretAgents from "./Components/Recruiter/AllRecuiretAgents/AllRecuiretAgents";
// import RecriterScriptandApi from "./Components/Recruiter/RecruiterAgent/Script&Api/RecruiterScriptandApi";
// import RecruiterKnowledge from "./Components/Recruiter/RecruiterAgent/Rag/RecruiterKnowledge";
// import AssesmentAnalysis from "./NewCompoents/Interviewer/Assesment-Analysis/AssesmentAnalysis";
// import InterviewPlatform from "./Components/InterviewPlatform/InterviewPlatform";
// import InterviewComplete from "./Components/InterviewPlatform/InterviewComplete";
// import ResumeScreen from "./NewCompoents/ResumeScreen/ResumeScreen";
// import CampaignManager from "../src/ElectionPartyComponent/CampaignManager";
// import ElectionPromptTemplate from "../src/ElectionPartyComponent/ElectionPromptTemplate";
// import ElectionAgentTemplate from "./ElectionPartyComponent/ElectionAgentTemplate";
// import CreateElectionOutBoundAgentComponent from "./ElectionPartyComponent/CreateElectionOutBoundAgentComponent";
// import ElectionEditOutboundAgent from "./ElectionPartyComponent/ElectionEditOutboundAgent";
// import ElectionCallerbook from "./ElectionPartyComponent/ElectionCallerbook";
// import CampaignCallTypeViewer from "./Components/ElectionLog/CampaignCallTypeViewer";

// const Dashboard = () => (
//   <div style={{ padding: 24 }}>
//     <h1>Dashboard </h1>
//     <p>
//       This is the Dashboard page (Health Care) — replace with real component.
//     </p>
//   </div>
// );

// const Patients = () => (
//   <div style={{ padding: 24 }}>
//     <h1>Patients</h1>
//     <p>
//       This is the Patients page (Health Care) — replace with real component.
//     </p>
//   </div>
// );

// const Appointments = () => (
//   <div style={{ padding: 24 }}>
//     <h1>Appointments</h1>
//     <p>This is the Appointments page (Health Care).</p>
//   </div>
// );

// const Doctors = () => (
//   <div style={{ padding: 24 }}>
//     <h1>Doctors</h1>
//     <p>This is the Doctors page (Health Care).</p>
//   </div>
// );

// // Fix: Replace recursive RecruiterDashboard with a placeholder
// const RecruiterDashboard = () => (
//   <div style={{ padding: 24 }}>
//     <h1>Recruiter Dashboard</h1>
//     <p>This is the Recruiter Dashboard — replace with real component.</p>
//   </div>
// );

// const ProtectedRoute = ({ children, requiredRoles }) => {
//   const dispatch = useDispatch();
//   const { token, isAuthenticated, role } = useSelector((state) => state.auth);
//   const location = useLocation();

//   // Move hooks to the top
//   const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);
//   const [hasAnimated, setHasAnimated] = React.useState(true);

//   useEffect(() => {
//     if (!token || !isAuthenticated) {
//       console.warn("ProtectedRoute: No token found, redirecting to /");
//       dispatch(logout());
//       return;
//     }

//     try {
//       const decodedToken = jwtDecode(token);
//       const currentTime = Date.now() / 1000;

//       if (decodedToken.exp < currentTime) {
//         console.warn("ProtectedRoute: Token expired, logging out");
//         dispatch(logout());
//         alert("Session expired. Please log in again.");
//       }
//     } catch (error) {
//       console.error("ProtectedRoute: Error decoding token:", error);
//       dispatch(logout());
//     }
//   }, [token, isAuthenticated, role, requiredRoles, dispatch]);

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//     if (!hasAnimated) {
//       setHasAnimated(true);
//     }
//   };

//   const menuContext = location.pathname.startsWith("/outbound")
//     ? "outbound-agent"
//     : location.pathname.startsWith("/inbound")
//     ? "inbound-agent"
//     : "default";

//   if (!token || !isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (requiredRoles && !requiredRoles.includes(role?.toLowerCase())) {
//     console.warn(`ProtectedRoute: Unauthorized role ${role}, redirecting to /`);
//     return <Navigate to="/" replace />;
//   }

//   return (
//     <div
//       className="protected-content"
//       style={{
//         display: "flex",
//         flexDirection: window.innerWidth >= 640 ? "row" : "column",
//       }}
//     >
//       <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={toggleSidebar}
//         hasAnimated={hasAnimated}
//         menuContext={menuContext}
//       />
//       <div className={`content ${isSidebarOpen ? "shifted" : ""}`}>
//         <HeaderBar />
//         {children}
//       </div>
//     </div>
//   );
// };

// const RoleBasedDashboard = () => {
//   const role = useSelector((state) => state.auth.role)?.toLowerCase();
//   const userData = JSON.parse(localStorage.getItem("authData") || "{}");
//   const domainType = userData.user?.domain?.toLowerCase() || "default";

//   if (!role) {
//     console.warn("RoleBasedDashboard: No role found, redirecting to /login");
//     return <Navigate to="/login" replace />;
//   }

//   // Logic to determine dashboard based on role and domainType
//   if (domainType === "recruiter") {
//     switch (role) {
//       case "vendor":
//         return <RecruiterDashboard />;
//       case "owner":
//         return <AdminDashboard />;
//       case "subowner":
//         return <SubAdminDashboard />;
//       case "participant":
//         return <SalesPersonDashboard />;
//       default:
//         console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
//         return <Navigate to="/login" replace />;
//     }
//   } else if (domainType === "health care") {
//     switch (role) {
//       case "owner":
//         return <AdminDashboard />;
//       case "subowner":
//         return <SubAdminDashboard />;
//       case "vendor":
//         return <VendorDashboard />;
//       case "participant":
//         return <Dashboard />;
//       default:
//         console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
//         return <Navigate to="/login" replace />;
//     }
//   } else if (domainType === "election party") {
//     switch (role) {
//       case "electionparty":
//          return <CampaignManager/>;
//       default:
//         console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
//         return <Navigate to="/login" replace />;
//     }
//   } else {
//     // Default domain behavior
//     switch (role) {
//       case "owner":
//         return <AdminDashboard />;
//       case "subowner":
//         return <SubAdminDashboard />;
//       case "vendor":
//         return <VendorDashboard />;
//       case "participant":
//         return <SalesPersonDashboard />;
//         case "electionparty": 
//           return <CampaignManager/>;
//       default:
//         console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
//         return <Navigate to="/login" replace />;
//     }
//   }
// };

// // Public Route Layout Component
// const PublicRouteLayout = ({ children }) => (
//   <div>
//     <Navbar />
//     {children}
//     <FooterComponent />
//   </div>
// );

// const App = () => {
//   const role = useSelector((state) => state.auth.role)?.toLowerCase() || null;
//   const { isAuthenticated, token } = useSelector((state) => state.auth);
//   const userData = JSON.parse(localStorage.getItem("authData") || "{}");
//   const domainType = userData.user?.domain?.toLowerCase() || "default";

//   console.log("Domain from localStorage:", domainType);

//   useEffect(() => {
//     if (role && localStorage.getItem("role") !== role) {
//       localStorage.setItem("role", role);
//     }
//   }, [role]);

//   return (
//     <>
//       <ToastContainer
//         position="top-right"
//         autoClose={2000}
//         style={{ zIndex: 99999999 }}
//       />
//       <Router>
//         <ScrollToTop />
//         <Routes>
//           {/* Public Routes Wrapped with Navbar and Footer */}
//           <Route
//             path="/login"
//             element={
//               isAuthenticated && token ? (
//                 <Navigate to="/" replace />
//               ) : (
//                 <AuthComponent />
//               )
//             }
//           />
//           <Route
//             path="/help"
//             element={
//               <PublicRouteLayout>
//                 <HelpCenter />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/terms-of-service"
//             element={
//               <PublicRouteLayout>
//                 <TermsOfService />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/privacy-Policy"
//             element={
//               <PublicRouteLayout>
//                 <PrivacyPolicy />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/faq"
//             element={
//               <PublicRouteLayout>
//                 <FaqComponent />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/blogs"
//             element={
//               <PublicRouteLayout>
//                 <Blog />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/customer-support"
//             element={
//               <PublicRouteLayout>
//                 <CustomerSupport />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/new-ChatBot"
//             element={
//               <PublicRouteLayout>
//                 <NewChatBot />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/demo-form"
//             element={
//               <PublicRouteLayout>
//                 <DemoForm />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="ai-recruiter/resume"
//             element={
//               <PublicRouteLayout>
//                 <ResumeScreen />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-support/live-chat"
//             element={
//               <PublicRouteLayout>
//                 <LiveChatSupport />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-support/ticket-resolution"
//             element={
//               <PublicRouteLayout>
//                 <TicketResolution />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-sales/lead-qualification"
//             element={
//               <PublicRouteLayout>
//                 <LeadQualification />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-sales/pitch"
//             element={
//               <PublicRouteLayout>
//                 <SalesPitchAutomation />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-sales/follow-up"
//             element={
//               <PublicRouteLayout>
//                 <FollowUpManagement />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/why-us"
//             element={
//               <PublicRouteLayout>
//                 <WhyToxbox />
//               </PublicRouteLayout>
//             }
//           />

//           <Route
//             path="/voice"
//             element={
//               <PublicRouteLayout>
//                 <VoiceComponent />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/toxboxSection"
//             element={
//               <PublicRouteLayout>
//                 <ToxboxSection />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/audios"
//             element={
//               <PublicRouteLayout>
//                 <AudioPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-recuter"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-support"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-sales"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-booking"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/voice-ai"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-interviewer/assessment"
//             element={
//               <PublicRouteLayout>
//                 <AssesmentAnalysis />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/sport-agent"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/smart-agent"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/insights"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/gen-ai-consulting"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/poc-to-production"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/case-studies"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/reports"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/knowledge-center"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/blog"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/customer-showcase"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/tech-blog"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/webinars"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-conversations"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/partnerships"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/careers"
//             element={
//               <PublicRouteLayout>
//                 <Careers />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/contact"
//             element={
//               <PublicRouteLayout>
//                 <DynamicPage />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-recruiter/sourcing"
//             element={
//               <PublicRouteLayout>
//                 <AIRecruiter />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/news"
//             element={
//               <PublicRouteLayout>
//                 <NewandMedia />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-tech/troubleshooting"
//             element={
//               <PublicRouteLayout>
//                 <AITechSupport />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-tech/software"
//             element={
//               <PublicRouteLayout>
//                 <SoftwareAssistance />
//               </PublicRouteLayout>
//             }
//           />
//           <Route
//             path="/ai-tech/hardware"
//             element={
//               <PublicRouteLayout>
//                 <HardwareSupport />
//               </PublicRouteLayout>
//             }
//           />

//           {/* Protected Routes */}
//           <Route
//             path="/"
//             element={
//               role ? (
//                 <ProtectedRoute
//                   requiredRoles={["owner", "subowner", "vendor", "participant" ,"electionparty"]}
//                 >
//                   <RoleBasedDashboard />
//                 </ProtectedRoute>
//               ) : (
//                 <PublicRouteLayout>
//                   <HomeComponent />
//                 </PublicRouteLayout>
//               )
//             }
//           />
//           <Route
//             path="/user-management"
//             element={
//               <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
//                 <UserManagement />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/agents-template"
//             element={
//               <ProtectedRoute requiredRoles={["electionparty"]}>
//                 <ElectionAgentTemplate />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//           path="/call-logs" 
//           element={
//           <ProtectedRoute requiredRoles={["electionparty"]}>
//          <CampaignCallTypeViewer/>
//               </ProtectedRoute>}
//           />
//           <Route
//             path="/election/create-agent"
//             element={
//               <ProtectedRoute requiredRoles={["electionparty"]}>
//                 <CreateElectionOutBoundAgentComponent />
//               </ProtectedRoute>
//             }
//           />
//           {/* <Route
//             path="/election/edit-agent/:agentId"
//             element={
//               <ProtectedRoute requiredRoles={["electionparty"]}>
//                 <ElectionEditOutboundAgent />
//               </ProtectedRoute>
//             }
//           /> */}
//           <Route
//           path ="/callerbook"
//           element={
//             <ProtectedRoute requiredRoles={["electionparty"]}>
//               <ElectionCallerbook />
//             </ProtectedRoute>
//           }
//           />  
//           <Route
//             path="/developer"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <Developer />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/recharge"
//             element={
//               <ProtectedRoute requiredRoles={["owner", "subowner"]}>
//                 <VendorBalancePage />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/campaign"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <Campaign />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/demoform"
//             element={
//               <ProtectedRoute requiredRoles={["owner"]}>
//                 <DemoList />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/approval"
//             element={
//               <ProtectedRoute requiredRoles={["owner"]}>
//                 <Approval />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/setting"
//             element={
//               <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
//                 <Setting />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/AgentScriptFull"
//             element={
//               <ProtectedRoute requiredRoles={["participant"]}>
//                 <AgentScriptFull />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/SalesPersonInfo"
//             element={
//               <ProtectedRoute requiredRoles={["participant"]}>
//                 <SalesPersonInfo />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/support"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant"]}
//               >
//                 <HelpCenter />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/show-ticket"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <ShowTicket />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/outbound/rag"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <VendorKnowledge />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/rag"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <VendorKnowledge />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/outbound/scripts"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant", "electionparty"]}>
//                 <ScriptandApi />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/scripts"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant", "electionparty"]}>
//                 <ScriptandApi />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/prompt-template"
//             element={
//               <ProtectedRoute requiredRoles={["electionparty"]}>
//                 <ElectionPromptTemplate />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/sources/:corpusId"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <CorpusSources />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/playground"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <Playground />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/callbook"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant"]}
//               >
//                 <CallBook />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/assignpage"
//             element={
//               <ProtectedRoute requiredRoles={["participant"]}>
//                 <AgentAssignComponent />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/assign"
//             element={
//               <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
//                 <AssignComponent />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/BalanceStatement"
//             element={
//               <ProtectedRoute requiredRoles={["vendor"]}>
//                 <BalanceStatement />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/project"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <CreateProject />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/calllogs"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <CallLogsCampaign />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/call-history/:campaignId"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <CallHistory />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/calllogs/details/:id"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <CallDetails />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/Result"
//             element={
//               <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                 <ResultComponent />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/keys"
//             element={
//               <ProtectedRoute requiredRoles={["owner"]}>
//                 <KeysComponent />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/calltype"
//             element={
//               <ProtectedRoute requiredRoles={["participant", "vendor", "electionparty"]}>
//                 <CallTypeComponent />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/OutboundCallDashboard"
//             element={
//               <ProtectedRoute requiredRoles={["participant"]}>
//                 <OutboundCallDashboard />
//               </ProtectedRoute>
//             }
//           />
//           {/* Outbound Routes */}
//           <Route path="/outbound">
//             <Route
//               index
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant","electionparty"]}
//                 >
//                   <OutboundTemplate />
//                 </ProtectedRoute>
//               }
//             />
//             <Route path="/outbound/createagent">
//               <Route
//                 index
//                 element={
//                   <ProtectedRoute
//                     requiredRoles={["subowner", "vendor", "participant" ,"electionparty"]}
//                   >
//                     {/* <MultiStepForm isEditMode={false} /> */}
//                     <CreateOutBoundAgentComponent isEditMode={false} />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="knowledge-bases"
//                 element={
//                   <ProtectedRoute
//                     requiredRoles={["subowner", "vendor", "participant","electionparty"]}
//                   >
//                     <KnowledgeBase />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="numbers"
//                 element={
//                   <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
//                     <NumberManagement />
//                   </ProtectedRoute>
//                 }
//               />
//             </Route>
//             <Route
//               path="/outbound/edit-agents/:agentId"
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant", "electionparty"]}
//                 >
//                   <EditAgentComponent isEditMode={true} />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="template"
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant","electionparty"]}
//                 >
//                   <TemplateComponent />
//                 </ProtectedRoute>
//               }
//             />
//           </Route>
//           {/* Inbound Routes */}
//           <Route path="/inbound">
//             <Route
//               index
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant","electionparty"]}
//                 >
//                   <InboundTemplate />
//                 </ProtectedRoute>
//               }
//             />
//             <Route path="/inbound/createagent">
//               <Route
//                 index
//                 element={
//                   <ProtectedRoute
//                     requiredRoles={["subowner", "vendor", "participant", "electionparty"]}
//                   >
//                     <MultiStepForm isEditMode={true} />
//                     {/* <CreateInBoundAgentComponent isEditMode={false} /> */}
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="knowledge-base"
//                 element={
//                   <ProtectedRoute
//                     requiredRoles={["subowner", "vendor", "participant"]}
//                   >
//                     <VendorKnowledge />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="script"
//                 element={
//                   <ProtectedRoute requiredRoles={["vendor", "participant"]}>
//                     <ScriptandApi />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="number"
//                 element={
//                   <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
//                     <NumberManagement />
//                   </ProtectedRoute>
//                 }
//               />
//             </Route>
//             <Route
//               path="edit-agent/:agentId"
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant", "electionparty"]}
//                 >
//                   <MultiStepForm isEditMode={true} />
//                   <CreateInBoundAgentComponent isEditMode={true} />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="template"
//               element={
//                 <ProtectedRoute
//                   requiredRoles={["subowner", "vendor", "participant"]}
//                 >
//                   <TemplateComponent />
//                 </ProtectedRoute>
//               }
//             />
//           </Route>
//           {/* Health Care Domain Routes */}
//           <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <Dashboard />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/patients"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <Patients />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/appointments"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <Appointments />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/doctors"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["owner", "subowner", "vendor", "participant"]}
//               >
//                 <Doctors />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/recruiter/createagent"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant","electionparty"]}
//               >
//                 {/* <RecruiterAgnetPage isEditMode={false} /> */}
//                 <CreateOutBoundAgentComponent isEditMode={false} />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/recruiter/api-key"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant", "electionparty"]}
//               >
//                 {/* <ApiKeyGenerator /> */}
//                 <CreateOutBoundAgentComponent isEditMode={false} />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/recruiter/all-agents"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant"]}
//               >
//                 <AllRecuiretAgents />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/recruiter/prompts"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant"]}
//               >
//                 <RecriterScriptandApi />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/recruiter/knoledge-base"
//             element={
//               <ProtectedRoute
//                 requiredRoles={["subowner", "vendor", "participant"]}
//               >
//                 <RecruiterKnowledge />
//               </ProtectedRoute>
//             }
//           />

//           {/* Routes Not in Sidebar Menus */}
//           <Route path="/contect" element={<Navigate to="/" replace />} />
//           <Route path="/api" element={<Navigate to="/" replace />} />
//           <Route path="/data" element={<Navigate to="/" replace />} />
//           <Route path="/subscription" element={<Navigate to="/" replace />} />
//           <Route path="/analysis" element={<Navigate to="/" replace />} />
//           <Route path="/int" element={<ConnectMetaAds />} />
//           <Route path="/camp" element={<CampaignsDashboard />} />
//           <Route path="/lead" element={<LeadsDashboard />} />
//           <Route path="/election" element={<CampaignManager/>}/>
//           <Route
//             path="/interview/:candidateId"
//             element={<InterviewPlatform />}
//           />
//           <Route path="/interview/complete" element={<InterviewComplete />} />
//           {/* Catch-all Route */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </Router>
//     </>
//   );
// };

// export default App;



import { jwtDecode } from "jwt-decode";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateProject from "../src/NewCompoents/Client/Project/CreateProject";
import "./App.css";
import Approval from "./Components/Admin/Approval";
import AudioPage from "./Components/AudioPage/AudioPage";
import AuthComponent from "./Components/AuthComponent/AuthComponent";
import Blog from "./Components/Blog/Blog";
import CallTypeComponent from "./Components/CallTypeComponent/CallTypeComponent";
import CreateInBoundAgentComponent from "./Components/CreateAgentComponent/CreateInBoundAgentComponent";
import CreateOutBoundAgentComponent from "./Components/CreateAgentComponent/CreateOutBoundAgentComponent";
import CustomerSupport from "./Components/CustomerSupport/CustomerSupport";
import FaqComponent from "./Components/FaqComponent/FaqComponent";
import HelpCenter from "./Components/HelpCenter/HelpCenter";
import HomeComponent from "./Components/HomeComponent/HomeComponent";
import InboundTemplate from "./Components/InboundTemplate/InboundTemplate";
import KnowledgeBase from "./Components/KnowledgeBase/KnowledgeBase";
import NumberManagement from "./Components/NumberManagement/NumberManagement";
import OutboundCallDashboard from "./Components/OutboundCallDashboard/OutboundCallDashboard";
import OutboundTemplate from "./Components/OutboundTemplate/OutboundTemplate";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Campaign from "./Components/RealStateVendor/Campaign";
import Developer from "./Components/RealStateVendor/Developer";
import ResultComponent from "./Components/ResultComponent/ResultComponent";
import ScriptandApi from "./Components/Script&Api/ScriptandApi";
import Setting from "./Components/Setting/Setting";
import Sidebar from "./Components/Sidebar/Sidebar";
import TemplateComponent from "./Components/TemplateComponent/TemplateComponent";
import TermsOfService from "./Components/TermsOfService/TermsOfService";
import ToxboxSection from "./Components/ToxboxSection/ToxboxSection";
import VoiceComponent from "./Components/VoiceComponent/VoiceComponent";
import AdminDashboard from "./NewCompoents/Admin/AdminDashboard/AdminDashboard";
import AssignComponent from "./NewCompoents/AssignComponent/AssignComponent";
import CallBook from "./NewCompoents/CallBook/CallBook";
import CallDetails from "./NewCompoents/Client/CallHistory/CallDetails";
import HeaderBar from "./NewCompoents/HeaderBar/HeaderBar";
import SubAdminDashboard from "./NewCompoents/SubAdmin/SubAdminDashboard/SubAdminDashboard";
import UserManagement from "./NewCompoents/UserManagement/UserManagement";
import VendorBalancePage from "./NewCompoents/VendorBalancePage/VendorBalancePage";
import AgentAssignComponent from "./Components/AgentAssignComponent/AgentAssignComponent";
import EditAgentComponent from "./Components/EditAgentComponent/EditAgentComponent";
import ShowTicket from "./Components/HelpCenter/ShowTicket";
import NewChatBot from "./Components/NewChatbot/NewChatBot";
import VendorDashboard from "./Components/VendorDashboard/VendorDashboard";
import BalanceStatement from "./NewCompoents/BalanceStatement/BalanceStatement";
import CallLogsCampaign from "./NewCompoents/CallLogsCampaign/CallLogsCampaign";
import CallHistory from "./NewCompoents/Client/CallHistory/CallHistory";
import Playground from "./NewCompoents/Playground/Playground";
import CorpusSources from "./NewCompoents/Rag/CorpusSources";
import VendorKnowledge from "./NewCompoents/Rag/VendorKnowledge";
import AgentScriptFull from "./NewCompoents/SalesPerson/SalesPersonDashboard/AgentScriptFull";
import SalesPersonDashboard from "./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonDashboard";
import SalesPersonInfo from "./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonInfo";
import { logout } from "./redux/authSlice";
import ScrollToTop from "./ScrollToTop";
import LeadQualification from "../src/NewCompoents/SalesAgent/LeadQualification";
// import NewandMedia from "./Components/AINews&Media/NewandMedia.js";
import AIRecruiter from "./Components/AIRecruiter/AIRecruiter.js";
import AITechSupport from "./Components/AITechSupport/AITechSupport";
import HardwareSupport from "./Components/HardwareSupport/HardwareSupport";
import DynamicPage from "./Components/HomeComponent/DynamicPage/DynamicPage";
import Navbar from "./Components/HomeComponent/Navbar";
import SoftwareAssistance from "./Components/SoftwareAssistance/SoftwareAssistance";
import WhyToxbox from "./Components/WhyUs/WhyToxbox";
import DemoForm from "./NewCompoents/Demoform/DemoForm";
import DemoList from "./NewCompoents/Demoform/DemoList/DemoList";
import LiveChatSupport from "./NewCompoents/LiveChatSupport/LiveChatSupport";
import FollowUpManagement from "./NewCompoents/SalesAgent/FollowUpManagement";
import SalesPitchAutomation from "./NewCompoents/SalesAgent/SalesPitchAutomation";
import TicketResolution from "./NewCompoents/TicketResolution/TicketResolution";
import Careers from "./Components/Career/Careers";
import FooterComponent from "./Components/Footer/FooterComponent";
import KeysComponent from "./Components/KeysComponent/KeysComponent";
import ConnectMetaAds from "./Components/MetaIntegration/ConnectMetaAds";
import CampaignsDashboard from "./Components/MetaIntegration/CampaignsDashboard";
import LeadsDashboard from "./Components/MetaIntegration/LeadsDashboard";
import MultiStepForm from "./Components/MultiStepForm/MultiStepForm";
import RecruiterAgnetPage from "./Components/Recruiter/RecruiterAgent/MultiStepForm/RecruiterAgentPage";
import ApiKeyGenerator from "./Components/Recruiter/RecruiterApiKey/ApiKeyGenerator";
import AllRecuiretAgents from "./Components/Recruiter/AllRecuiretAgents/AllRecuiretAgents";
import RecriterScriptandApi from "./Components/Recruiter/RecruiterAgent/Script&Api/RecruiterScriptandApi";
import RecruiterKnowledge from "./Components/Recruiter/RecruiterAgent/Rag/RecruiterKnowledge";
import AssesmentAnalysis from "./NewCompoents/Interviewer/Assesment-Analysis/AssesmentAnalysis";
import InterviewPlatform from "./Components/InterviewPlatform/InterviewPlatform";
import InterviewComplete from "./Components/InterviewPlatform/InterviewComplete";
import ResumeScreen from "./NewCompoents/ResumeScreen/ResumeScreen";
import CampaignManager from "../src/ElectionPartyComponent/CampaignManager";
import ElectionPromptTemplate from "../src/ElectionPartyComponent/ElectionPromptTemplate";
import ElectionAgentTemplate from "./ElectionPartyComponent/ElectionAgentTemplate";
import CreateElectionOutBoundAgentComponent from "./ElectionPartyComponent/CreateElectionOutBoundAgentComponent";
import ElectionEditOutboundAgent from "./ElectionPartyComponent/ElectionEditOutboundAgent";
import ElectionCallerbook from "./ElectionPartyComponent/ElectionCallerbook";
import CampaignCallTypeViewer from "./Components/ElectionLog/CampaignCallTypeViewer";
import CampaignCreditAssignment from "./ElectionPartyComponent/CampaignCreditAssignment";
import ElectionNumber from "./Components/ElectionNumber/ElectionNumber";
import ElectionDashboard from "./ElectionPartyComponent/ElectionDashboard.jsx";
import CustomerFeedback from "./NewCompoents/CustomerSupport/CustomerFeedback.js";
import CandidateOutreach from "./Components/CandidateOutreach/CandidateOutreach.js";
import LeadGeneration from "./Components/LeadGeneration/LeadGeneration.js";
import LeadNurturing from "./Components/LeadNurturing/LeadNurturing.js";
import CRMIntegration from "./NewCompoents/CRMIntegration/CRMIntegration.jsx";
import ReservationManagement from "./NewCompoents/AIBookingAgent/ReservationManagement.jsx";
import AppointmnetBooking from "./NewCompoents/AIBookingAgent/AppointmnetBooking.jsx";
import CalenderIntegration from "./NewCompoents/AIBookingAgent/CalenderIntegration.jsx";
import Contact from "./Components/Contactus/Contact.js";
import InterviewScheduling from "./NewCompoents/Interviewer/Interview-Scheduling/InterviewScheduling.jsx";
import CandidateScreening from "./NewCompoents/Interviewer/Candidate-Screening/CandidateScreening.jsx";
// import Contact from "./Components/ContactUs/Contact.js";

const Dashboard = () => (
  <div style={{ padding: 24 }}>
    <h1>Dashboard </h1>
    <p>
      This is the Dashboard page (Health Care) — replace with real component.
    </p>
  </div>
);

const Patients = () => (
  <div style={{ padding: 24 }}>
    <h1>Patients</h1>
    <p>
      This is the Patients page (Health Care) — replace with real component.
    </p>
  </div>
);

const Appointments = () => (
  <div style={{ padding: 24 }}>
    <h1>Appointments</h1>
    <p>This is the Appointments page (Health Care).</p>
  </div>
);

const Doctors = () => (
  <div style={{ padding: 24 }}>
    <h1>Doctors</h1>
    <p>This is the Doctors page (Health Care).</p>
  </div>
);

// Fix: Replace recursive RecruiterDashboard with a placeholder
const RecruiterDashboard = () => (
  <div style={{ padding: 24 }}>
    <h1>Recruiter Dashboard</h1>
    <p>This is the Recruiter Dashboard — replace with real component.</p>
  </div>
);

const ProtectedRoute = ({ children, requiredRoles }) => {
  const dispatch = useDispatch();
  const { token, isAuthenticated, role } = useSelector((state) => state.auth);
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData?.user?.domain?.toLowerCase() || "default";
  const userRole = role?.toLowerCase();

  // Move hooks to the top
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);
  const [hasAnimated, setHasAnimated] = React.useState(true);

  useEffect(() => {
    if (!token || !isAuthenticated) {
      console.warn("ProtectedRoute: No token found, redirecting to /");
      dispatch(logout());
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        console.warn("ProtectedRoute: Token expired, logging out");
        dispatch(logout());
        alert("Session expired. Please log in again.");
      }
    } catch (error) {
      console.error("ProtectedRoute: Error decoding token:", error);
      dispatch(logout());
    }
  }, [token, isAuthenticated, role, requiredRoles, dispatch]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    if (!hasAnimated) {
      setHasAnimated(true);
    }
  };

  const menuContext = location.pathname.startsWith("/outbound")
    ? "outbound-agent"
    : location.pathname.startsWith("/inbound")
      ? "inbound-agent"
      : "default";

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isAuthorized = !requiredRoles || requiredRoles.includes(userRole);

  if (!isAuthorized) {
    console.warn(`ProtectedRoute: Unauthorized role ${userRole}, redirecting to /`);
    return <Navigate to="/" replace />;
  }

  return (
    <div
      className="protected-content"
      style={{
        display: "flex",
        flexDirection: window.innerWidth >= 640 ? "row" : "column",
        overflow: "hidden"
      }}
    >
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        hasAnimated={hasAnimated}
        menuContext={menuContext}
      />
      <div className={`content ${isSidebarOpen ? "shifted" : ""}`}>
        <HeaderBar />
        {children}
      </div>
    </div>
  );
};

const RoleBasedDashboard = () => {
  const role = useSelector((state) => state.auth.role)?.toLowerCase();
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData.user?.domain?.toLowerCase() || "default";

  if (!role) {
    console.warn("RoleBasedDashboard: No role found, redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  // Logic to determine dashboard based on role and domainType
  if (domainType === "recruiter") {
    switch (role) {
      case "vendor":
        return <RecruiterDashboard />;
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "participant":
        return <SalesPersonDashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  } else if (domainType === "health care") {
    switch (role) {
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "vendor":
        return <VendorDashboard />;
      case "participant":
        return <Dashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  } else if (domainType === "election party") {
    return <ElectionDashboard />;
  } else {
    switch (role) {
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "vendor":
        return <VendorDashboard />;
      case "participant":
        return <SalesPersonDashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  }
};

// Public Route Layout Component
const PublicRouteLayout = ({ children }) => (
  <div>
    <Navbar />
    {children}
    <FooterComponent />
  </div>
);

const App = () => {
  const role = useSelector((state) => state.auth.role)?.toLowerCase() || null;
  const { isAuthenticated, token } = useSelector((state) => state.auth);
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData.user?.domain?.toLowerCase() || "default";

  console.log("Domain from localStorage:", domainType);

  useEffect(() => {
    if (role && localStorage.getItem("role") !== role) {
      localStorage.setItem("role", role);
    }
  }, [role]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        style={{ zIndex: 999999 , position: "fixed" }}
      />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes Wrapped with Navbar and Footer */}
          <Route
            path="/login"
            element={
              isAuthenticated && token ? (
                <Navigate to="/" replace />
              ) : (
                <AuthComponent />
              )
            }
          />
          <Route
            path="/help"
            element={
              <PublicRouteLayout>
                <HelpCenter />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <PublicRouteLayout>
                <TermsOfService />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/privacy-Policy"
            element={
              <PublicRouteLayout>
                <PrivacyPolicy />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/faq"
            element={
              <PublicRouteLayout>
                <FaqComponent />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/blogs"
            element={
              <PublicRouteLayout>
                <Blog />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/customer-support"
            element={
              <PublicRouteLayout>
                <CustomerSupport />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/new-ChatBot"
            element={
              <PublicRouteLayout>
                <NewChatBot />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/demo-form"
            element={
              <PublicRouteLayout>
                <DemoForm />
              </PublicRouteLayout>
            }
          />

          {/*  AI-Recruiter Routes*/}

          <Route
            path="ai-recruiter/resume"
            element={
              <PublicRouteLayout>
                <ResumeScreen />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-recruiter/sourcing"
            element={
              <PublicRouteLayout>
                <AIRecruiter />
              </PublicRouteLayout>
            }
          />

          <Route
            path="/ai-recruiter/outreach"
            element={
              <PublicRouteLayout>
                <CandidateOutreach />
              </PublicRouteLayout>
            }
          />

          {/* Customer Support AI Routes*/}
          <Route
            path="/ai-support/live-chat"
            element={
              <PublicRouteLayout>
                <LiveChatSupport />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-support/ticket-resolution"
            element={
              <PublicRouteLayout>
                <TicketResolution />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-support/feedback"
            element={
              <PublicRouteLayout>
                <CustomerFeedback />
              </PublicRouteLayout>
            }
          />


          {/* AI-sales Routes  */}
          <Route
            path="/ai-sales/lead-qualification"
            element={
              <PublicRouteLayout>
                <LeadQualification />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-sales/pitch"
            element={
              <PublicRouteLayout>
                <SalesPitchAutomation />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-sales/follow-up"
            element={
              <PublicRouteLayout>
                <FollowUpManagement />
              </PublicRouteLayout>
            }
          />

          {/* Lead Agents Routes*/}

          <Route
            path="/ai-lead/generation"
            element={
              <PublicRouteLayout>
                <LeadGeneration />
              </PublicRouteLayout>
            }
          />

          <Route
            path="/ai-lead/nurturing"
            element={
              <PublicRouteLayout>
                <LeadNurturing />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-lead/crm"
            element={
              <PublicRouteLayout>
                <CRMIntegration />
              </PublicRouteLayout>
            }
          />




          <Route
            path="/why-us"
            element={
              <PublicRouteLayout>
                <WhyToxbox />
              </PublicRouteLayout>
            }
          />

          <Route
            path="/voice"
            element={
              <PublicRouteLayout>
                <VoiceComponent />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/toxboxSection"
            element={
              <PublicRouteLayout>
                <ToxboxSection />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/audios"
            element={
              <PublicRouteLayout>
                <AudioPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-recuter"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-support"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-sales"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-booking"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          {/* AI Booking Agent Routes  */}
          <Route
            path="/ai-booking/appointment"
            element={
              <PublicRouteLayout>
                <AppointmnetBooking />
              </PublicRouteLayout>

            } />

          <Route
            path="/ai-booking/reservation"
            element={
              <PublicRouteLayout>
                <ReservationManagement />
              </PublicRouteLayout>

            } />

          <Route
            path="/ai-booking/calendar"
            element={
              <PublicRouteLayout>
                <CalenderIntegration />
              </PublicRouteLayout>

            } />


          <Route
            path="/voice-ai"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />


          {/* Routes for the AI-Interview */}
          <Route
            path="/ai-interviewer/assessment"
            element={
              <PublicRouteLayout>
                <AssesmentAnalysis />
              </PublicRouteLayout>
            }
          />

          <Route
            path="/ai-interviewer/scheduling"
            element={
              <PublicRouteLayout>
                <InterviewScheduling />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-interviewer/screening"
            element={
              <PublicRouteLayout>
                <CandidateScreening />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/sport-agent"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/smart-agent"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/insights"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/gen-ai-consulting"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/poc-to-production"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/case-studies"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/reports"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/knowledge-center"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/blog"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/customer-showcase"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/tech-blog"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/webinars"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-conversations"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/partnerships"
            element={
              <PublicRouteLayout>
                <DynamicPage />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/careers"
            element={
              <PublicRouteLayout>
                <Careers />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <PublicRouteLayout>
                <Contact />
              </PublicRouteLayout>
            }
          />
          {/* <Route
            path="/news"
            element={
              <PublicRouteLayout>
                <NewandMedia />
              </PublicRouteLayout>
            }
          /> */}
          <Route
            path="/ai-tech/troubleshooting"
            element={
              <PublicRouteLayout>
                <AITechSupport />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-tech/software"
            element={
              <PublicRouteLayout>
                <SoftwareAssistance />
              </PublicRouteLayout>
            }
          />
          <Route
            path="/ai-tech/hardware"
            element={
              <PublicRouteLayout>
                <HardwareSupport />
              </PublicRouteLayout>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              role ? (
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <RoleBasedDashboard />
                </ProtectedRoute>
              ) : (
                <PublicRouteLayout>
                  <HomeComponent />
                </PublicRouteLayout>
              )
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agents-template"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <ElectionAgentTemplate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/election-campaign"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <CampaignManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/call-logs"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <CampaignCallTypeViewer />
              </ProtectedRoute>}
          />

          <Route
            path="/assignCredit"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <CampaignCreditAssignment />
              </ProtectedRoute>}
          />
          <Route
            path="/election/create-agent"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <CreateElectionOutBoundAgentComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-agent/:agentId"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <ElectionEditOutboundAgent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/callerbook"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <ElectionCallerbook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/number"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <ElectionNumber />
              </ProtectedRoute>
            }
          />
          <Route
            path="/developer"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <Developer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recharge"
            element={
              <ProtectedRoute requiredRoles={["owner", "subowner"]}>
                <VendorBalancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaign"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <Campaign />
              </ProtectedRoute>
            }
          />
          <Route
            path="/demoform"
            element={
              <ProtectedRoute requiredRoles={["owner"]}>
                <DemoList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/approval"
            element={
              <ProtectedRoute requiredRoles={["owner"]}>
                <Approval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setting"
            element={
              <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
                <Setting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AgentScriptFull"
            element={
              <ProtectedRoute requiredRoles={["participant"]}>
                <AgentScriptFull />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesPersonInfo"
            element={
              <ProtectedRoute requiredRoles={["participant"]}>
                <SalesPersonInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                <HelpCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/show-ticket"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <ShowTicket />
              </ProtectedRoute>
            }
          />
          <Route
            path="/outbound/rag"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <VendorKnowledge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rag"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <VendorKnowledge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/outbound/scripts"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <ScriptandApi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scripts"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <ScriptandApi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prompt-template"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <ElectionPromptTemplate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sources/:corpusId"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <CorpusSources />
              </ProtectedRoute>
            }
          />
          <Route
            path="/playground"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <Playground />
              </ProtectedRoute>
            }
          />
          <Route
            path="/callbook"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                <CallBook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assignpage"
            element={
              <ProtectedRoute requiredRoles={["participant"]}>
                <AgentAssignComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assign"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                <AssignComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/BalanceStatement"
            element={
              <ProtectedRoute requiredRoles={["vendor"]}>
                <BalanceStatement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <CreateProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calllogs"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <CallLogsCampaign />
              </ProtectedRoute>
            }
          />
          <Route
            path="/call-history/:campaignId"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <CallHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calllogs/details/:id"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <CallDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Result"
            element={
              <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                <ResultComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/keys"
            element={
              <ProtectedRoute requiredRoles={["owner"]}>
                <KeysComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calltype"
            element={
              <ProtectedRoute requiredRoles={["participant", "vendor"]}>
                <CallTypeComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/OutboundCallDashboard"
            element={
              <ProtectedRoute requiredRoles={["participant"]}>
                <OutboundCallDashboard />
              </ProtectedRoute>
            }
          />
          {/* Outbound Routes */}
          <Route path="/outbound">
            <Route
              index
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <OutboundTemplate />
                </ProtectedRoute>
              }
            />
            <Route path="/outbound/createagent">
              <Route
                index
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    {/* <MultiStepForm isEditMode={false} /> */}
                    <CreateOutBoundAgentComponent isEditMode={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="knowledge-bases"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <KnowledgeBase />
                  </ProtectedRoute>
                }
              />
              <Route
                path="numbers"
                element={
                  <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                    <NumberManagement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/outbound/edit-agents/:agentId"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <EditAgentComponent isEditMode={true} />
                </ProtectedRoute>
              }
            />
            <Route
              path="template"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <TemplateComponent />
                </ProtectedRoute>
              }
            />
          </Route>
          {/* Inbound Routes */}
          <Route path="/inbound">
            <Route
              index
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <InboundTemplate />
                </ProtectedRoute>
              }
            />
            <Route path="/inbound/createagent">
              <Route
                index
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <MultiStepForm isEditMode={true} />
                    {/* <CreateInBoundAgentComponent isEditMode={false} /> */}
                  </ProtectedRoute>
                }
              />
              <Route
                path="knowledge-base"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <VendorKnowledge />
                  </ProtectedRoute>
                }
              />
              <Route
                path="script"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                    <ScriptandApi />
                  </ProtectedRoute>
                }
              />
              <Route
                path="number"
                element={
                  <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                    <NumberManagement />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="edit-agent/:agentId"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <MultiStepForm isEditMode={true} />
                  <CreateInBoundAgentComponent isEditMode={true} />
                </ProtectedRoute>
              }
            />
            <Route
              path="template"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <TemplateComponent />
                </ProtectedRoute>
              }
            />
          </Route>
          {/* Health Care Domain Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <Patients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <Appointments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/doctors"
            element={
              <ProtectedRoute
                requiredRoles={["owner", "subowner", "vendor", "participant"]}
              >
                <Doctors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recruiter/createagent"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                {/* <RecruiterAgnetPage isEditMode={false} /> */}
                <CreateOutBoundAgentComponent isEditMode={false} />
              </ProtectedRoute>
            }
          />


          <Route
            path="/recruiter/createagent"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                {/* <RecruiterAgnetPage isEditMode={false} /> */}
                <ElectionEditOutboundAgent />
              </ProtectedRoute>
            }
          />


          <Route
            path="/recruiter/api-key"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                {/* <ApiKeyGenerator /> */}
                <CreateOutBoundAgentComponent isEditMode={false} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/recruiter/all-agents"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                <AllRecuiretAgents />
              </ProtectedRoute>
            }
          />

          <Route
            path="/recruiter/prompts"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                <RecriterScriptandApi />
              </ProtectedRoute>
            }
          />

          <Route
            path="/recruiter/knoledge-base"
            element={
              <ProtectedRoute
                requiredRoles={["subowner", "vendor", "participant"]}
              >
                <RecruiterKnowledge />
              </ProtectedRoute>
            }
          />

          {/* Routes Not in Sidebar Menus */}
          {/* <Route path="/contect" element={<Navigate to="/" replace />} />
          <Route path="/api" element={<Navigate to="/" replace />} />
          <Route path="/data" element={<Navigate to="/" replace />} />
          <Route path="/subscription" element={<Navigate to="/" replace />} />
          <Route path="/analysis" element={<Navigate to="/" replace />} />
          <Route path="/meta-connect" element={<ConnectMetaAds />} />
          <Route path="/camp" element={<CampaignsDashboard />} />
          <Route path="/lead" element={<LeadsDashboard />} />
          <Route path="/election" element={<CampaignManager/>}/> 
          <Route
            path="/interview/:candidateId"
            element={<InterviewPlatform />}
          />
          <Route path="/interview/complete" element={<InterviewComplete />} /> */}
          {/* Catch-all Route */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}


          <Route
            path="/meta-connect"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <ConnectMetaAds />
              </ProtectedRoute>
            }
          />
          <Route
            path="/camp"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <CampaignsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lead"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <LeadsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/election"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <CampaignManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interview/:candidateId"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <InterviewPlatform />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interview/complete"
            element={
              <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                <InterviewComplete />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default App;